import { css } from '@bts-web/utils-style-engine';
import { RegularInfoWarning } from '../../../common/svgIcons/RegularInfoWarning';
import { GoToPortfolioButton } from '../../../common/components/buttons/GoToPortfolioButton/GoToPortfolioButton';
import { disclaimerSectionStyles } from '../Withdrawal/WithdrawalAmount/withdrawalAmountStyles';

export type ManualReviewScreenProps = {
  title: string;
  description?: string;
};

const containerStyles = css({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  mx: 'auto',
  gap: 'medium',
  pb: 'medium',
  alignItems: 'center',
  justifyContent: 'center',
  flex: 1,
  minHeight: '240px',
});

export const ManualReviewScreen = ({
  title,
  description,
}: ManualReviewScreenProps) => {
  return (
    <div
      className={css({
        display: 'flex',
        flexDirection: 'column',
        px: 'medium',
        py: 'small',
        justifyContent: 'space-between',
        height: '100%',
      })}
    >
      <section className={containerStyles}>
        <div
          className={css({ display: 'flex', justifyContent: 'center' })}
          aria-label="warning icon section"
        >
          <div
            className={css({
              width: '52px',
              height: '52px',
              color: 'warning.text_primary',
              backgroundColor: 'warning.fill_secondary',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '50%',
              flexShrink: 0,
            })}
          >
            <RegularInfoWarning size={36} />
          </div>
        </div>
        <h1
          className={css({
            fontSize: 'headline.medium',
            fontWeight: 'headline.large_semi_bold',
            lineHeight: 1.1,
            paddingBottom: 'large',
          })}
        >
          {title}
        </h1>
        {description && (
          <div
            className={`${disclaimerSectionStyles} ${css({
              mx: '0',
            })}`}
          >
            {description}
          </div>
        )}
      </section>
      <GoToPortfolioButton fullWidth size="large" />
    </div>
  );
};
